module.exports = __webpack_public_path__ + "img/concrete-hole-decal-05.c3a52c6c.png";